import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow SSO authentication.
 */
export class SsoOperations {
  constructor(private client: BaserowClient) {}
  
  // SSO methods will be implemented here
} 